import { useQuery } from '@tanstack/react-query'
import { listSessions, type SessionSummary } from '../lib/api.js'

/**
 * Recent chat sessions for the sidebar Récents block. Cached separately from
 * the full /sessions page query so the sidebar doesn't refetch on every page
 * change but still updates when a new session is created.
 */
export function useRecentSessions(limit = 8) {
  return useQuery<SessionSummary[]>({
    queryKey: ['sessions', 'recent', limit],
    queryFn: () => listSessions(limit),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  })
}
